export enum SurgeonsColumnId {
  SurgeonName = 'surgeon_name',
  Specialty = 'specialty',
  ContactNumbers = 'contact_numbers',
  EmailAddresses = 'email_addresses',
  Verification = 'verification',
  Status = 'status',
  Actions = 'actions',
}
